module.exports = __webpack_public_path__ + "img/woman.92c88a20.jpg";